import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { toast } from "sonner";

export interface BusinessType {
  id: string;
  name: string;
  description: string;
  features: Record<string, boolean>;
}

export interface BusinessTypeDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedType?: BusinessType | null;
  onClose: () => void;
  onSave: (formData: any) => Promise<void>;
}

export const BusinessTypeDialog = ({
  isOpen,
  onOpenChange,
  selectedType,
  onClose,
  onSave,
}: BusinessTypeDialogProps) => {
  const [formData, setFormData] = useState({
    name: selectedType?.name || "",
    description: selectedType?.description || "",
    features: selectedType?.features || {
      stock: true,
      budget: true,
      history: true,
      returns: true,
      counting: true,
      settings: true,
      poultry: false,
      credit: true,
    },
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFeatureChange = (feature: string) => {
    setFormData((prev) => ({
      ...prev,
      features: {
        ...prev.features,
        [feature]: !prev.features[feature],
      },
    }));
  };

  const handleSubmit = async () => {
    try {
      await onSave(formData);
      toast.success("Type d'entreprise enregistré avec succès");
      onClose();
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement du type d'entreprise");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {selectedType ? "Modifier le type d'entreprise" : "Ajouter un type d'entreprise"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Nom du type d'entreprise"
            className="input w-full px-3 py-2 border rounded-md"
          />
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Description"
            className="textarea w-full px-3 py-2 border rounded-md"
          />
          <div>
            <h3>Fonctionnalités</h3>
            {Object.keys(formData.features).map((feature) => (
              <label key={feature} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={formData.features[feature]}
                  onChange={() => handleFeatureChange(feature)}
                />
                <span>{feature}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <Button onClick={onClose} variant="outline" className="mr-2">Annuler</Button>
          <Button onClick={handleSubmit}>Enregistrer</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};